import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { AskDataMode } from '~src/settings/types/AskDataMode';

export function IsNlpEnabled(): boolean {
  const sessionManagementService = getSessionManagementServiceInstance();
  return sessionManagementService.isNlpServiceEnabled() &&
    (sessionManagementService.askDataMode() !== AskDataMode.DISABLED_ALWAYS);
}

